/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：product_list_pc（357 个 D 位坑位，15 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_LIST_PC_SPM_CODES = {
  breadcrumb: {
    code: `${sitePrefix}.product_list_pc.breadcrumb`,
    breadcrumb_item_01: `${sitePrefix}.product_list_pc.breadcrumb.breadcrumb_item_01`,
  },
  color_filter: {
    code: `${sitePrefix}.product_list_pc.color_filter`,
    color_option_01: `${sitePrefix}.product_list_pc.color_filter.color_option_01`,
    color_option_02: `${sitePrefix}.product_list_pc.color_filter.color_option_02`,
    color_option_03: `${sitePrefix}.product_list_pc.color_filter.color_option_03`,
    color_option_04: `${sitePrefix}.product_list_pc.color_filter.color_option_04`,
    color_option_05: `${sitePrefix}.product_list_pc.color_filter.color_option_05`,
    color_option_06: `${sitePrefix}.product_list_pc.color_filter.color_option_06`,
    color_option_07: `${sitePrefix}.product_list_pc.color_filter.color_option_07`,
    color_option_08: `${sitePrefix}.product_list_pc.color_filter.color_option_08`,
    color_option_09: `${sitePrefix}.product_list_pc.color_filter.color_option_09`,
    color_option_10: `${sitePrefix}.product_list_pc.color_filter.color_option_10`,
    color_option_11: `${sitePrefix}.product_list_pc.color_filter.color_option_11`,
    color_option_12: `${sitePrefix}.product_list_pc.color_filter.color_option_12`,
    color_option_13: `${sitePrefix}.product_list_pc.color_filter.color_option_13`,
    color_option_14: `${sitePrefix}.product_list_pc.color_filter.color_option_14`,
    color_option_15: `${sitePrefix}.product_list_pc.color_filter.color_option_15`,
    color_option_16: `${sitePrefix}.product_list_pc.color_filter.color_option_16`,
    color_option_17: `${sitePrefix}.product_list_pc.color_filter.color_option_17`,
    color_option_18: `${sitePrefix}.product_list_pc.color_filter.color_option_18`,
    color_option_19: `${sitePrefix}.product_list_pc.color_filter.color_option_19`,
    color_option_20: `${sitePrefix}.product_list_pc.color_filter.color_option_20`,
    color_option_21: `${sitePrefix}.product_list_pc.color_filter.color_option_21`,
    color_option_22: `${sitePrefix}.product_list_pc.color_filter.color_option_22`,
    color_option_23: `${sitePrefix}.product_list_pc.color_filter.color_option_23`,
    color_option_24: `${sitePrefix}.product_list_pc.color_filter.color_option_24`,
    toggle_color_filter: `${sitePrefix}.product_list_pc.color_filter.toggle_color_filter`,
  },
  gender_filter: {
    code: `${sitePrefix}.product_list_pc.gender_filter`,
    gender_option_01: `${sitePrefix}.product_list_pc.gender_filter.gender_option_01`,
    gender_option_02: `${sitePrefix}.product_list_pc.gender_filter.gender_option_02`,
    toggle_gender_filter: `${sitePrefix}.product_list_pc.gender_filter.toggle_gender_filter`,
  },
  list_faq: {
    code: `${sitePrefix}.product_list_pc.list_faq`,
    open_answer_link_01: `${sitePrefix}.product_list_pc.list_faq.open_answer_link_01`,
    toggle_question_01: `${sitePrefix}.product_list_pc.list_faq.toggle_question_01`,
    toggle_question_02: `${sitePrefix}.product_list_pc.list_faq.toggle_question_02`,
    toggle_question_03: `${sitePrefix}.product_list_pc.list_faq.toggle_question_03`,
    toggle_question_04: `${sitePrefix}.product_list_pc.list_faq.toggle_question_04`,
    toggle_question_05: `${sitePrefix}.product_list_pc.list_faq.toggle_question_05`,
    toggle_question_06: `${sitePrefix}.product_list_pc.list_faq.toggle_question_06`,
    toggle_question_07: `${sitePrefix}.product_list_pc.list_faq.toggle_question_07`,
    toggle_question_08: `${sitePrefix}.product_list_pc.list_faq.toggle_question_08`,
    toggle_question_09: `${sitePrefix}.product_list_pc.list_faq.toggle_question_09`,
    toggle_question_10: `${sitePrefix}.product_list_pc.list_faq.toggle_question_10`,
    toggle_question_11: `${sitePrefix}.product_list_pc.list_faq.toggle_question_11`,
    toggle_question_12: `${sitePrefix}.product_list_pc.list_faq.toggle_question_12`,
    toggle_question_13: `${sitePrefix}.product_list_pc.list_faq.toggle_question_13`,
  },
  list_toolbar: {
    code: `${sitePrefix}.product_list_pc.list_toolbar`,
    open_sort: `${sitePrefix}.product_list_pc.list_toolbar.open_sort`,
  },
  material_filter: {
    code: `${sitePrefix}.product_list_pc.material_filter`,
    material_option_01: `${sitePrefix}.product_list_pc.material_filter.material_option_01`,
    material_option_02: `${sitePrefix}.product_list_pc.material_filter.material_option_02`,
    material_option_03: `${sitePrefix}.product_list_pc.material_filter.material_option_03`,
    material_option_04: `${sitePrefix}.product_list_pc.material_filter.material_option_04`,
    material_option_05: `${sitePrefix}.product_list_pc.material_filter.material_option_05`,
    material_option_06: `${sitePrefix}.product_list_pc.material_filter.material_option_06`,
    material_option_07: `${sitePrefix}.product_list_pc.material_filter.material_option_07`,
    material_option_08: `${sitePrefix}.product_list_pc.material_filter.material_option_08`,
    material_option_09: `${sitePrefix}.product_list_pc.material_filter.material_option_09`,
    toggle_material_filter: `${sitePrefix}.product_list_pc.material_filter.toggle_material_filter`,
  },
  pagination: {
    code: `${sitePrefix}.product_list_pc.pagination`,
    next_page: `${sitePrefix}.product_list_pc.pagination.next_page`,
    page_number_01: `${sitePrefix}.product_list_pc.pagination.page_number_01`,
    page_number_02: `${sitePrefix}.product_list_pc.pagination.page_number_02`,
    page_number_03: `${sitePrefix}.product_list_pc.pagination.page_number_03`,
    page_number_04: `${sitePrefix}.product_list_pc.pagination.page_number_04`,
    page_number_05: `${sitePrefix}.product_list_pc.pagination.page_number_05`,
    page_number_06: `${sitePrefix}.product_list_pc.pagination.page_number_06`,
    previous_page: `${sitePrefix}.product_list_pc.pagination.previous_page`,
  },
  prescription_filter: {
    code: `${sitePrefix}.product_list_pc.prescription_filter`,
    prescription_option_01: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_01`,
    prescription_option_02: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_02`,
    prescription_option_03: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_03`,
    prescription_option_04: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_04`,
    prescription_option_05: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_05`,
    prescription_option_06: `${sitePrefix}.product_list_pc.prescription_filter.prescription_option_06`,
    toggle_prescription_filter: `${sitePrefix}.product_list_pc.prescription_filter.toggle_prescription_filter`,
  },
  price_filter: {
    code: `${sitePrefix}.product_list_pc.price_filter`,
    price_option_01: `${sitePrefix}.product_list_pc.price_filter.price_option_01`,
    price_option_02: `${sitePrefix}.product_list_pc.price_filter.price_option_02`,
    price_option_03: `${sitePrefix}.product_list_pc.price_filter.price_option_03`,
    price_option_04: `${sitePrefix}.product_list_pc.price_filter.price_option_04`,
    price_option_05: `${sitePrefix}.product_list_pc.price_filter.price_option_05`,
    toggle_price_filter: `${sitePrefix}.product_list_pc.price_filter.toggle_price_filter`,
  },
  product_results: {
    code: `${sitePrefix}.product_list_pc.product_results`,
    color_swatch_001_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_001_01`,
    color_swatch_001_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_001_02`,
    color_swatch_002_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_002_01`,
    color_swatch_002_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_002_02`,
    color_swatch_003_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_01`,
    color_swatch_003_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_02`,
    color_swatch_003_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_03`,
    color_swatch_003_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_04`,
    color_swatch_003_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_05`,
    color_swatch_003_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_003_06`,
    color_swatch_004_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_004_01`,
    color_swatch_004_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_004_02`,
    color_swatch_004_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_004_03`,
    color_swatch_005_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_005_01`,
    color_swatch_005_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_005_02`,
    color_swatch_005_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_005_03`,
    color_swatch_006_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_006_01`,
    color_swatch_006_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_006_02`,
    color_swatch_006_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_006_03`,
    color_swatch_006_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_006_04`,
    color_swatch_007_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_01`,
    color_swatch_007_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_02`,
    color_swatch_007_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_03`,
    color_swatch_007_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_04`,
    color_swatch_007_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_05`,
    color_swatch_007_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_007_06`,
    color_swatch_008_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_008_01`,
    color_swatch_008_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_008_02`,
    color_swatch_008_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_008_03`,
    color_swatch_008_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_008_04`,
    color_swatch_009_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_009_01`,
    color_swatch_009_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_009_02`,
    color_swatch_010_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_01`,
    color_swatch_010_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_02`,
    color_swatch_010_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_03`,
    color_swatch_010_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_04`,
    color_swatch_010_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_05`,
    color_swatch_010_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_010_06`,
    color_swatch_011_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_011_01`,
    color_swatch_011_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_011_02`,
    color_swatch_011_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_011_03`,
    color_swatch_012_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_012_01`,
    color_swatch_012_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_012_02`,
    color_swatch_012_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_012_03`,
    color_swatch_012_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_012_04`,
    color_swatch_013_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_013_01`,
    color_swatch_013_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_013_02`,
    color_swatch_013_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_013_03`,
    color_swatch_014_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_01`,
    color_swatch_014_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_02`,
    color_swatch_014_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_03`,
    color_swatch_014_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_04`,
    color_swatch_014_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_05`,
    color_swatch_014_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_014_06`,
    color_swatch_015_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_015_01`,
    color_swatch_015_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_015_02`,
    color_swatch_015_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_015_03`,
    color_swatch_016_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_01`,
    color_swatch_016_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_02`,
    color_swatch_016_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_03`,
    color_swatch_016_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_04`,
    color_swatch_016_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_05`,
    color_swatch_016_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_016_06`,
    color_swatch_017_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_017_01`,
    color_swatch_017_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_017_02`,
    color_swatch_018_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_01`,
    color_swatch_018_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_02`,
    color_swatch_018_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_03`,
    color_swatch_018_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_04`,
    color_swatch_018_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_05`,
    color_swatch_018_06: `${sitePrefix}.product_list_pc.product_results.color_swatch_018_06`,
    color_swatch_019_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_019_01`,
    color_swatch_019_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_019_02`,
    color_swatch_019_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_019_03`,
    color_swatch_020_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_020_01`,
    color_swatch_020_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_020_02`,
    color_swatch_020_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_020_03`,
    color_swatch_021_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_021_01`,
    color_swatch_021_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_021_02`,
    color_swatch_021_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_021_03`,
    color_swatch_022_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_022_01`,
    color_swatch_022_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_022_02`,
    color_swatch_022_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_022_03`,
    color_swatch_022_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_022_04`,
    color_swatch_023_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_023_01`,
    color_swatch_023_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_023_02`,
    color_swatch_023_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_023_03`,
    color_swatch_024_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_024_01`,
    color_swatch_024_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_024_02`,
    color_swatch_025_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_025_01`,
    color_swatch_025_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_025_02`,
    color_swatch_025_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_025_03`,
    color_swatch_026_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_026_01`,
    color_swatch_026_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_026_02`,
    color_swatch_026_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_026_03`,
    color_swatch_027_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_027_01`,
    color_swatch_027_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_027_02`,
    color_swatch_027_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_027_03`,
    color_swatch_027_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_027_04`,
    color_swatch_027_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_027_05`,
    color_swatch_028_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_028_01`,
    color_swatch_028_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_028_02`,
    color_swatch_028_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_028_03`,
    color_swatch_028_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_028_04`,
    color_swatch_029_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_029_01`,
    color_swatch_029_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_029_02`,
    color_swatch_029_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_029_03`,
    color_swatch_029_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_029_04`,
    color_swatch_030_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_030_01`,
    color_swatch_030_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_030_02`,
    color_swatch_030_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_030_03`,
    color_swatch_031_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_031_01`,
    color_swatch_031_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_031_02`,
    color_swatch_031_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_031_03`,
    color_swatch_031_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_031_04`,
    color_swatch_032_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_032_01`,
    color_swatch_032_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_032_02`,
    color_swatch_032_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_032_03`,
    color_swatch_033_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_033_01`,
    color_swatch_033_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_033_02`,
    color_swatch_033_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_033_03`,
    color_swatch_034_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_034_01`,
    color_swatch_034_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_034_02`,
    color_swatch_034_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_034_03`,
    color_swatch_034_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_034_04`,
    color_swatch_035_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_035_01`,
    color_swatch_035_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_035_02`,
    color_swatch_035_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_035_03`,
    color_swatch_035_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_035_04`,
    color_swatch_036_01: `${sitePrefix}.product_list_pc.product_results.color_swatch_036_01`,
    color_swatch_036_02: `${sitePrefix}.product_list_pc.product_results.color_swatch_036_02`,
    color_swatch_036_03: `${sitePrefix}.product_list_pc.product_results.color_swatch_036_03`,
    color_swatch_036_04: `${sitePrefix}.product_list_pc.product_results.color_swatch_036_04`,
    color_swatch_036_05: `${sitePrefix}.product_list_pc.product_results.color_swatch_036_05`,
    favorite_001: `${sitePrefix}.product_list_pc.product_results.favorite_001`,
    favorite_002: `${sitePrefix}.product_list_pc.product_results.favorite_002`,
    favorite_003: `${sitePrefix}.product_list_pc.product_results.favorite_003`,
    favorite_004: `${sitePrefix}.product_list_pc.product_results.favorite_004`,
    favorite_005: `${sitePrefix}.product_list_pc.product_results.favorite_005`,
    favorite_006: `${sitePrefix}.product_list_pc.product_results.favorite_006`,
    favorite_007: `${sitePrefix}.product_list_pc.product_results.favorite_007`,
    favorite_008: `${sitePrefix}.product_list_pc.product_results.favorite_008`,
    favorite_009: `${sitePrefix}.product_list_pc.product_results.favorite_009`,
    favorite_010: `${sitePrefix}.product_list_pc.product_results.favorite_010`,
    favorite_011: `${sitePrefix}.product_list_pc.product_results.favorite_011`,
    favorite_012: `${sitePrefix}.product_list_pc.product_results.favorite_012`,
    favorite_013: `${sitePrefix}.product_list_pc.product_results.favorite_013`,
    favorite_014: `${sitePrefix}.product_list_pc.product_results.favorite_014`,
    favorite_015: `${sitePrefix}.product_list_pc.product_results.favorite_015`,
    favorite_016: `${sitePrefix}.product_list_pc.product_results.favorite_016`,
    favorite_017: `${sitePrefix}.product_list_pc.product_results.favorite_017`,
    favorite_018: `${sitePrefix}.product_list_pc.product_results.favorite_018`,
    favorite_019: `${sitePrefix}.product_list_pc.product_results.favorite_019`,
    favorite_020: `${sitePrefix}.product_list_pc.product_results.favorite_020`,
    favorite_021: `${sitePrefix}.product_list_pc.product_results.favorite_021`,
    favorite_022: `${sitePrefix}.product_list_pc.product_results.favorite_022`,
    favorite_023: `${sitePrefix}.product_list_pc.product_results.favorite_023`,
    favorite_024: `${sitePrefix}.product_list_pc.product_results.favorite_024`,
    favorite_025: `${sitePrefix}.product_list_pc.product_results.favorite_025`,
    favorite_026: `${sitePrefix}.product_list_pc.product_results.favorite_026`,
    favorite_027: `${sitePrefix}.product_list_pc.product_results.favorite_027`,
    favorite_028: `${sitePrefix}.product_list_pc.product_results.favorite_028`,
    favorite_029: `${sitePrefix}.product_list_pc.product_results.favorite_029`,
    favorite_030: `${sitePrefix}.product_list_pc.product_results.favorite_030`,
    favorite_031: `${sitePrefix}.product_list_pc.product_results.favorite_031`,
    favorite_032: `${sitePrefix}.product_list_pc.product_results.favorite_032`,
    favorite_033: `${sitePrefix}.product_list_pc.product_results.favorite_033`,
    favorite_034: `${sitePrefix}.product_list_pc.product_results.favorite_034`,
    favorite_035: `${sitePrefix}.product_list_pc.product_results.favorite_035`,
    favorite_036: `${sitePrefix}.product_list_pc.product_results.favorite_036`,
    product_001: `${sitePrefix}.product_list_pc.product_results.product_001`,
    product_002: `${sitePrefix}.product_list_pc.product_results.product_002`,
    product_003: `${sitePrefix}.product_list_pc.product_results.product_003`,
    product_004: `${sitePrefix}.product_list_pc.product_results.product_004`,
    product_005: `${sitePrefix}.product_list_pc.product_results.product_005`,
    product_006: `${sitePrefix}.product_list_pc.product_results.product_006`,
    product_007: `${sitePrefix}.product_list_pc.product_results.product_007`,
    product_008: `${sitePrefix}.product_list_pc.product_results.product_008`,
    product_009: `${sitePrefix}.product_list_pc.product_results.product_009`,
    product_010: `${sitePrefix}.product_list_pc.product_results.product_010`,
    product_011: `${sitePrefix}.product_list_pc.product_results.product_011`,
    product_012: `${sitePrefix}.product_list_pc.product_results.product_012`,
    product_013: `${sitePrefix}.product_list_pc.product_results.product_013`,
    product_014: `${sitePrefix}.product_list_pc.product_results.product_014`,
    product_015: `${sitePrefix}.product_list_pc.product_results.product_015`,
    product_016: `${sitePrefix}.product_list_pc.product_results.product_016`,
    product_017: `${sitePrefix}.product_list_pc.product_results.product_017`,
    product_018: `${sitePrefix}.product_list_pc.product_results.product_018`,
    product_019: `${sitePrefix}.product_list_pc.product_results.product_019`,
    product_020: `${sitePrefix}.product_list_pc.product_results.product_020`,
    product_021: `${sitePrefix}.product_list_pc.product_results.product_021`,
    product_022: `${sitePrefix}.product_list_pc.product_results.product_022`,
    product_023: `${sitePrefix}.product_list_pc.product_results.product_023`,
    product_024: `${sitePrefix}.product_list_pc.product_results.product_024`,
    product_025: `${sitePrefix}.product_list_pc.product_results.product_025`,
    product_026: `${sitePrefix}.product_list_pc.product_results.product_026`,
    product_027: `${sitePrefix}.product_list_pc.product_results.product_027`,
    product_028: `${sitePrefix}.product_list_pc.product_results.product_028`,
    product_029: `${sitePrefix}.product_list_pc.product_results.product_029`,
    product_030: `${sitePrefix}.product_list_pc.product_results.product_030`,
    product_031: `${sitePrefix}.product_list_pc.product_results.product_031`,
    product_032: `${sitePrefix}.product_list_pc.product_results.product_032`,
    product_033: `${sitePrefix}.product_list_pc.product_results.product_033`,
    product_034: `${sitePrefix}.product_list_pc.product_results.product_034`,
    product_035: `${sitePrefix}.product_list_pc.product_results.product_035`,
    product_036: `${sitePrefix}.product_list_pc.product_results.product_036`,
    try_on_001: `${sitePrefix}.product_list_pc.product_results.try_on_001`,
    try_on_002: `${sitePrefix}.product_list_pc.product_results.try_on_002`,
    try_on_003: `${sitePrefix}.product_list_pc.product_results.try_on_003`,
    try_on_004: `${sitePrefix}.product_list_pc.product_results.try_on_004`,
    try_on_005: `${sitePrefix}.product_list_pc.product_results.try_on_005`,
    try_on_006: `${sitePrefix}.product_list_pc.product_results.try_on_006`,
    try_on_007: `${sitePrefix}.product_list_pc.product_results.try_on_007`,
    try_on_008: `${sitePrefix}.product_list_pc.product_results.try_on_008`,
    try_on_009: `${sitePrefix}.product_list_pc.product_results.try_on_009`,
    try_on_010: `${sitePrefix}.product_list_pc.product_results.try_on_010`,
    try_on_011: `${sitePrefix}.product_list_pc.product_results.try_on_011`,
    try_on_012: `${sitePrefix}.product_list_pc.product_results.try_on_012`,
    try_on_013: `${sitePrefix}.product_list_pc.product_results.try_on_013`,
    try_on_014: `${sitePrefix}.product_list_pc.product_results.try_on_014`,
    try_on_015: `${sitePrefix}.product_list_pc.product_results.try_on_015`,
    try_on_016: `${sitePrefix}.product_list_pc.product_results.try_on_016`,
    try_on_017: `${sitePrefix}.product_list_pc.product_results.try_on_017`,
    try_on_018: `${sitePrefix}.product_list_pc.product_results.try_on_018`,
    try_on_019: `${sitePrefix}.product_list_pc.product_results.try_on_019`,
    try_on_020: `${sitePrefix}.product_list_pc.product_results.try_on_020`,
    try_on_021: `${sitePrefix}.product_list_pc.product_results.try_on_021`,
    try_on_022: `${sitePrefix}.product_list_pc.product_results.try_on_022`,
    try_on_023: `${sitePrefix}.product_list_pc.product_results.try_on_023`,
    try_on_024: `${sitePrefix}.product_list_pc.product_results.try_on_024`,
    try_on_025: `${sitePrefix}.product_list_pc.product_results.try_on_025`,
    try_on_026: `${sitePrefix}.product_list_pc.product_results.try_on_026`,
    try_on_027: `${sitePrefix}.product_list_pc.product_results.try_on_027`,
    try_on_028: `${sitePrefix}.product_list_pc.product_results.try_on_028`,
    try_on_029: `${sitePrefix}.product_list_pc.product_results.try_on_029`,
    try_on_030: `${sitePrefix}.product_list_pc.product_results.try_on_030`,
    try_on_031: `${sitePrefix}.product_list_pc.product_results.try_on_031`,
    try_on_032: `${sitePrefix}.product_list_pc.product_results.try_on_032`,
    try_on_033: `${sitePrefix}.product_list_pc.product_results.try_on_033`,
    try_on_034: `${sitePrefix}.product_list_pc.product_results.try_on_034`,
    try_on_035: `${sitePrefix}.product_list_pc.product_results.try_on_035`,
    try_on_036: `${sitePrefix}.product_list_pc.product_results.try_on_036`,
  },
  related_categories_bottom: {
    code: `${sitePrefix}.product_list_pc.related_categories_bottom`,
    category_entry_01: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_01`,
    category_entry_02: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_02`,
    category_entry_03: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_03`,
    category_entry_04: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_04`,
    category_entry_05: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_05`,
    category_entry_06: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_06`,
    category_entry_07: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_07`,
    category_entry_08: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_08`,
    category_entry_09: `${sitePrefix}.product_list_pc.related_categories_bottom.category_entry_09`,
  },
  seo_content: {
    code: `${sitePrefix}.product_list_pc.seo_content`,
    next: `${sitePrefix}.product_list_pc.seo_content.next`,
    open_progressive_glasses: `${sitePrefix}.product_list_pc.seo_content.open_progressive_glasses`,
    open_rectangle_glasses: `${sitePrefix}.product_list_pc.seo_content.open_rectangle_glasses`,
    open_titanium_glasses: `${sitePrefix}.product_list_pc.seo_content.open_titanium_glasses`,
    previous: `${sitePrefix}.product_list_pc.seo_content.previous`,
    select_article_01: `${sitePrefix}.product_list_pc.seo_content.select_article_01`,
    select_article_02: `${sitePrefix}.product_list_pc.seo_content.select_article_02`,
    select_article_03: `${sitePrefix}.product_list_pc.seo_content.select_article_03`,
  },
  shape_filter: {
    code: `${sitePrefix}.product_list_pc.shape_filter`,
    shape_option_01: `${sitePrefix}.product_list_pc.shape_filter.shape_option_01`,
    shape_option_02: `${sitePrefix}.product_list_pc.shape_filter.shape_option_02`,
    shape_option_03: `${sitePrefix}.product_list_pc.shape_filter.shape_option_03`,
    shape_option_04: `${sitePrefix}.product_list_pc.shape_filter.shape_option_04`,
    shape_option_05: `${sitePrefix}.product_list_pc.shape_filter.shape_option_05`,
    shape_option_06: `${sitePrefix}.product_list_pc.shape_filter.shape_option_06`,
    shape_option_07: `${sitePrefix}.product_list_pc.shape_filter.shape_option_07`,
    shape_option_08: `${sitePrefix}.product_list_pc.shape_filter.shape_option_08`,
    shape_option_09: `${sitePrefix}.product_list_pc.shape_filter.shape_option_09`,
    toggle_shape_filter: `${sitePrefix}.product_list_pc.shape_filter.toggle_shape_filter`,
  },
  size_filter: {
    code: `${sitePrefix}.product_list_pc.size_filter`,
    size_option_01: `${sitePrefix}.product_list_pc.size_filter.size_option_01`,
    size_option_02: `${sitePrefix}.product_list_pc.size_filter.size_option_02`,
    size_option_03: `${sitePrefix}.product_list_pc.size_filter.size_option_03`,
    size_option_04: `${sitePrefix}.product_list_pc.size_filter.size_option_04`,
    size_option_05: `${sitePrefix}.product_list_pc.size_filter.size_option_05`,
    toggle_size_filter: `${sitePrefix}.product_list_pc.size_filter.toggle_size_filter`,
  },
  sort_options: {
    code: `${sitePrefix}.product_list_pc.sort_options`,
    sort_option_01: `${sitePrefix}.product_list_pc.sort_options.sort_option_01`,
    sort_option_02: `${sitePrefix}.product_list_pc.sort_options.sort_option_02`,
    sort_option_03: `${sitePrefix}.product_list_pc.sort_options.sort_option_03`,
    sort_option_04: `${sitePrefix}.product_list_pc.sort_options.sort_option_04`,
    sort_option_05: `${sitePrefix}.product_list_pc.sort_options.sort_option_05`,
    sort_option_06: `${sitePrefix}.product_list_pc.sort_options.sort_option_06`,
    sort_option_07: `${sitePrefix}.product_list_pc.sort_options.sort_option_07`,
  },
} as const satisfies SpmPageCodes;
